const DISCLOSURE_ROUTES = [
  '/disclosures',
  '/disclosure',
  '/auto-closed-disclosure',
];

export const isValidDisclosurePath = (path: string): boolean => {
  const [pathname] = path.split('?');
  return DISCLOSURE_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
};
